const isPro = Object.is(process.env.NODE_ENV, 'production')
 
// console.log("是否正式环境："+isPro);
 
module.exports = {
  // baseUrl: isPro ? 'http://127.0.0.1:8081' : ''
  baseUrl: isPro ? '' : ''
}



//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 3